import React, { useMemo, useState } from 'react';
import DHeader from '../../pieces/DHeader';
import DText from '../../pieces/DText';
import DCode from '../../pieces/DCode';

export default function WhatIsAnAgent() {

    return (
        <div>
            <DHeader>What is an Agent?</DHeader>
       
            <DText>
              AI Agents are systems that can perform tasks autonomously. When we talk about agents here, 
              we are referring to LLM powered agents.
            </DText>
            <DText>
              LLM Agents typically use LLMs to handle reasoning and decision making. 
              Given a task, the orchestrator gets the LLM to reason and decide on the next step to be taken and tool to be used.
              Tools could be functions, API calls, calls to LLMs, database queries and so on. These tools help the agent perform a particular action.
            </DText>
            
          
       
        </div>
    )
}